import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Add,
  AddContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-add',
  template: Add.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Add.height;
  @Input() public viewBox: string = getSVGViewBox(Add.viewBox);
  @Input() public width: number | string = Add.width;
  @Input()
  public set context(ctx: AddContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: AddContext = Add.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = AddComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Add.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
